import React from 'react'
import { Button } from '../../pages/home/components/HeroSession.js/HeroSession.styles';
import { FormContainer, InputContainer } from '../betaForm/BetaDetail'

const AutoLoanDetail = () => {
  return (
    <FormContainer>
      <InputContainer>
        <div>
          <label>Where do you work currently?</label>
          <input placeholder="eg Coca Cola" />
        </div>
        <div>
          <label>Monthly Salary?</label>
          <input placeholder="eg 500,000" />
        </div>
        <div>
          <label>Enter make & model of the car</label>
          <input placeholder="eg Toyota Camry, 2019 model" />
        </div>
        <div>
          <label>What is the price of the car?</label>
          <input placeholder="eg 5 Million Naira" />
        </div>
      </InputContainer>
      <div className="submit__button">
        <Button
          style={{ color: "#fff", fontSize: "16px", marginTop: "20px" }}
          to="/contact"
        >
          Finish
        </Button>
      </div>
    </FormContainer>
  );
}

export default AutoLoanDetail;
